/* eslint-disable */

import {
  getCollectionMachinePresentation,
  hasPresentationRent,
} from "utils/collectionMachinePresentation";

const getRentPrice = (machine = {}) =>
  machine?.HistoricalRent?.Price ?? machine?.Rent?.Price ?? machine?.RentPrice ?? 0;

const compactFormula = (formulaDisplay) =>
  String(formulaDisplay ?? "")
    .replace(/\s+/g, "")
    .trim();

export const isNegativeCollectionAmount = (value) => {
  if (value === null || value === undefined || value === "") return false;
  const numericValue = Number(value);
  return Number.isFinite(numericValue) && numericValue < 0;
};

export const getCollectionGeneralListPresentation = (
  machine = {},
  { moneyFormat = (value) => String(value) } = {}
) => {
  const presentation = getCollectionMachinePresentation(machine);
  const isRented = hasPresentationRent(machine);

  if (isRented) {
    return {
      showLocalDisplayNumber: false,
      secondaryText: `Alquiler: ${moneyFormat(getRentPrice(machine))}`,
    };
  }

  const secondaryParts = [];
  if (presentation.showFormula) {
    if (machine?.IsAccumulative === false) secondaryParts.push("Borrado");
    secondaryParts.push(compactFormula(presentation.formulaDisplay));
  }
  if (presentation.showTokenPrice) {
    secondaryParts.push(`Ficha: ${moneyFormat(presentation.tokenPrice)}`);
  }

  return {
    showLocalDisplayNumber: presentation.type === "Tragamoneda",
    secondaryText: secondaryParts.filter(Boolean).join(" · "),
  };
};
